import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Monitoring\DeferredPropsLoopController::__invoke
* @see Http/Controllers/Api/Monitoring/DeferredPropsLoopController.php:17
* @route '/api/monitoring/deferred-props-loop'
*/
const DeferredPropsLoopController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DeferredPropsLoopController.url(options),
    method: 'post',
})

DeferredPropsLoopController.definition = {
    methods: ["post"],
    url: '/api/monitoring/deferred-props-loop',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Monitoring\DeferredPropsLoopController::__invoke
* @see Http/Controllers/Api/Monitoring/DeferredPropsLoopController.php:17
* @route '/api/monitoring/deferred-props-loop'
*/
DeferredPropsLoopController.url = (options?: RouteQueryOptions) => {
    return DeferredPropsLoopController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Monitoring\DeferredPropsLoopController::__invoke
* @see Http/Controllers/Api/Monitoring/DeferredPropsLoopController.php:17
* @route '/api/monitoring/deferred-props-loop'
*/
DeferredPropsLoopController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DeferredPropsLoopController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Monitoring\DeferredPropsLoopController::__invoke
* @see Http/Controllers/Api/Monitoring/DeferredPropsLoopController.php:17
* @route '/api/monitoring/deferred-props-loop'
*/
const DeferredPropsLoopControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: DeferredPropsLoopController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Monitoring\DeferredPropsLoopController::__invoke
* @see Http/Controllers/Api/Monitoring/DeferredPropsLoopController.php:17
* @route '/api/monitoring/deferred-props-loop'
*/
DeferredPropsLoopControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: DeferredPropsLoopController.url(options),
    method: 'post',
})

DeferredPropsLoopController.form = DeferredPropsLoopControllerForm

export default DeferredPropsLoopController